import script from "./dynamicTreeTable copy.vue?vue&type=script&setup=true&lang=js"
export * from "./dynamicTreeTable copy.vue?vue&type=script&setup=true&lang=js"

import "./dynamicTreeTable copy.vue?vue&type=style&index=0&id=02a12e5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02a12e5c"]])

export default __exports__